import { Injectable } from '@angular/core';
import { Event, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
// import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(
    private platform: Platform,
    private router: Router,
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
          // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
          // Hide loading indicator
          this.trackScreen(event.url);
      }

      if (event instanceof NavigationError) {
          // Hide loading indicator

          // Present error to user
      }
  });
  }

  // Copied from app.service due to injector problems
  private isMobileApp() {
    return Capacitor.isNativePlatform();
  }

  initAnalytics() {
    // Mixpanel removed - using Firebase Analytics only
  }

  async identify(user: any) {
    // Firebase Analytics disabled
    // if(this.isMobileApp()) {
    //   try {
    //     await FirebaseAnalytics.setUserId({ userId: user.uid });
    //   } catch (error) {
    //     console.error('Error setting Firebase Analytics user ID:', error);
    //   }
    // }
  }

  async clearUser() {
    // Firebase Analytics disabled
    // if(this.isMobileApp()) {
    //   try {
    //     await FirebaseAnalytics.setUserId({ userId: null });
    //   } catch (error) {
    //     console.error('Error clearing Firebase Analytics user ID:', error);
    //   }
    // }
  }

  // Tracks a custom event in Firebase Analytics
  async logEvent(name: string, properties?: object) {
    // Firebase Analytics disabled
    // if(this.isMobileApp()) {
    //   try {
    //     await FirebaseAnalytics.logEvent({
    //       name: name,
    //       params: properties || {}
    //     });
    //   } catch (error) {
    //     console.error('Error logging Firebase Analytics event:', error);
    //   }
    // }
  }

  async setUserProperty(key: string, value: string) {
    // Firebase Analytics disabled
    // if(this.isMobileApp()) {
    //   try {
    //     await FirebaseAnalytics.setUserProperty({
    //       key: key,
    //       value: value
    //     });
    //   } catch (error) {
    //     console.error('Error setting Firebase Analytics user property:', error);
    //   }
    // }
  }

  // Tracks an 'screen_view' event in Firebase Analytics
  async trackScreen(name: string) {
    // Firebase Analytics disabled
    // if(this.isMobileApp()) {
    //   try {
    //     await FirebaseAnalytics.setCurrentScreen({
    //       screenName: name,
    //     });
    //   } catch (error) {
    //     console.error('Error tracking Firebase Analytics screen:', error);
    //   }
    // }
  }

}
